import { CommonDialogs } from "@mcleod/common";
import { ClickEvent, Label, Toast } from "@mcleod/components";
import { Api, Model } from "@mcleod/core";
import { StopList } from "./StopList";
import { AutogenLayoutCancelStopSelection } from "./autogen/AutogenLayoutCancelStopSelection";

export class CancelStopSelection extends AutogenLayoutCancelStopSelection {
    private _doAfterClose: (canceled: boolean) => void;

    override onLoad() {
        const stopList = this.layoutStopList as StopList;
        stopList.showCommentsAndReference = false;
        stopList.tableStop.allowDelete = false;
    }

    private unclearStops() {
        this.savebuttonRollback.primaryButton.busy = true;
        return Api.update("lme/dispatch/unclear-stops",
            {
                "movement_id": this.sourceMovement.activeRow.get("id"),
                "stop_id": (this.layoutStopList as StopList).tableStop.selectedRow.data.get("id")
            }).then(response => {
                this.close(false);
            }).catch(error => CommonDialogs.showError(error))
            .finally(() => { this.savebuttonRollback.primaryButton.busy = false });
    }


    savebuttonRollbackOnClick(event: ClickEvent) {
        this.checkDetention().then(result => {
            if (result.hasDetention) {
                CommonDialogs.showYesNo(result.detentionText, "Rollback Stops", {maxWidth: 650}).then(clickedYes => {
                    if (clickedYes) {
                        return this.unclearStops();
                    } else {
                        return Promise.resolve();
                    }
                });
            } else {
                return this.unclearStops();
            }
        });
    }

    close(canceled: boolean) {
        this.slideOut().then(() => {
            if (this.doAfterClose != null) {
                this.doAfterClose(canceled);
            }
        });
    }

    public set doAfterClose(f) {
        this._doAfterClose = f;
    }

    public get doAfterClose() {
        return this._doAfterClose;
    }
    

    public checkDetention() {
        const movementId = this.sourceMovement.activeRow.get("id");
         return Model.searchSingleRecord("lme/dispatch/unclear-stops", {"movement_id": movementId}).then((response) => ({
            hasDetention: response.getBoolean("has_detention", false),
            detentionText: response.getString("detention_text", null)
         }));
    }
}
